import { render, staticRenderFns } from "./lucky.vue?vue&type=template&id=4ef7d495&scoped=true"
import script from "./lucky.vue?vue&type=script&lang=js"
export * from "./lucky.vue?vue&type=script&lang=js"
import style0 from "./lucky.vue?vue&type=style&index=0&id=4ef7d495&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ef7d495",
  null
  
)

export default component.exports